import React from "react";

import { useTranslation } from "react-i18next";

import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";
import { Button } from "@components/buttons";

export default function AppUpdatedPage(props: { reload: () => void }) {
	const { t } = useTranslation();
	return (
		<DesktopLayout>
			<section className="l--content l--content--full">
				<div className="l--content__main">
					<div className="container">
						<div className="card--primary card--shadowy card--message">
							<div className="card--message__thumb" />
							<div className="card--message__body">
								<div className="card--message__content">
									<>
										<i className="card--message__icon u-icon u-icon--xlrg u-icon--refresh u-icon--animated--bounce-in u-color--sent--success" />
										<div className="card--message__title">
											{t<string>("APP_UPDATED.TITLE")}
										</div>
										<div className="u-type--center">
											{t<string>(
												"APP_UPDATED.MESSAGE_DETAILS"
											)}
										</div>
									</>
									<div className="card--message__footer">
										<Button
											type="button"
											onClick={() => props.reload()}
											atClassName="AppUpdatedPage__btn--primary"
											className="btn--base btn--block btn--accent btn--animate-rotate"
											iconLeft
											iconClassName="u-icon--sml u-icon--refresh u-color--accent--text"
											btnText={t<string>(
												"APP_UPDATED.UPDATE_BUTTON"
											)}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</DesktopLayout>
	);
}
